import { type FC } from "react";
import { Dialog } from "@mui/material";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useCreatePostMutation } from "@/partner/entities/posts";
import { type PostFormValues } from "../model";
import { PostForm } from "./PostForm";
import type { CreatePostInputType } from "@/types/graphql/partner.generated";

interface CreatePostDialogProps {
  open: boolean;
  onClose: () => void;
  onCompleted?: () => void;
}

export const CreatePostDialog: FC<CreatePostDialogProps> = ({
  open,
  onClose,
  onCompleted,
}) => {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  const [createPost, { loading }] = useCreatePostMutation({
    onCompleted: () => {
      enqueueSnackbar(t("posts.create.success"), { variant: "success" });
      onCompleted?.();
    },
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: "error" });
    },
    refetchQueries: ["PostsList"],
  });

  const handleSubmit = async (values: PostFormValues) => {
    await createPost({
      variables: {
        input: values as CreatePostInputType,
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <PostForm
        onSubmit={handleSubmit}
        onClose={onClose}
        title={t("posts.create.title")}
        loading={loading}
      />
    </Dialog>
  );
};
